<div class="toggleButton toolbarLabel">
  <input type="checkbox" id="findMatchDiacritics" tabindex="0" />
  <label for="findMatchDiacritics" data-l10n-id="pdfjs-find-match-diacritics-checkbox-label"></label>
</div>
